import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_CONFIG = gql`
  mutation UpdateConfig($where: ConfigUniqueInput!, $data: UpdateConfigInput) {
    updateConfig(where: $where, data: $data) {
      message
    }
  }
`;
